import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { SessionActions } from '../account/sessionSlice';
import { gql } from '../graphql/generated';
import type { OrganizationSettingsInput } from '../graphql/generated/graphql';

const UPDATE_ORGANIZATION_SETTINGS_MUTATION = gql(/** @complexity 4 */ `
  mutation updateOrganizationSettings(
    $settings: OrganizationSettingsInput!
  ) {
    organization: updateOrganization(settings: $settings) {
      id
      settings {
        ...setOrganizationSettings_settings
      }
    }
  }
`);

const useUpdateOrganizationSettings = () => {
  const [updateOrganizationSettings] = useMutation(
    UPDATE_ORGANIZATION_SETTINGS_MUTATION,
  );
  const dispatch = useDispatch();

  return useCallback(
    async (settings: OrganizationSettingsInput) => {
      const response = await updateOrganizationSettings({
        variables: {
          settings,
        },
      });

      if (response.data) {
        dispatch(
          SessionActions.setOrganizationSettings(
            response.data.organization.settings,
          ),
        );
      }
    },
    [updateOrganizationSettings, dispatch],
  );
};

export default useUpdateOrganizationSettings;
